import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

function InstoreOnlyPill() {
  return <div className="mn_instoreOnlyPill">In-store offer only</div>;
}

export default (props) => <ComponentErrorBoundary><InstoreOnlyPill {...props} /></ComponentErrorBoundary>;
